import React from 'react';

import MuiIconButton from '@material-ui/core/IconButton';
import MuiEditAttributesIcon from '@material-ui/icons/EditAttributes';
import MuiBlockIcon from '@material-ui/icons/Block';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiEditOutlinedIcon from '@material-ui/icons/EditOutlined';
import MuiFileCopyIcon from '@material-ui/icons/FileCopy';
import MuiArchiveIcon from '@material-ui//icons/Archive';
import MuiChangeIcon from '@material-ui//icons/GroupWorkSharp';
import MuiUnarchiveIcon from '@material-ui//icons/Unarchive';

import { WithTooltip } from 'utils/wrappers';

const RowButtons = props => {
  const {
    editing,
    onEditChange,
    onCloneClick,
    isCloning,
    onChangeUPCClicked,
    isArchived,
    onArchiveToggle,
    isArchiving,
    onChangeReleaseGroup,
    isRefetching,
    status,
  } = props;

  // Listeners

  const handleEditClick = () => onEditChange(true);
  const handleCancelClick = () => {
    onEditChange(false);
    onChangeReleaseGroup(true);
    onChangeUPCClicked(true);
  };
  const handleCloneReleaseClick = () => onCloneClick();
  const handleChangeReleaseGroup = () => onChangeReleaseGroup();
  const handleChangeUPCGroup = () => onChangeUPCClicked();
  // Components

  const ActionInProgress = (
    <MuiIconButton disabled={true}>
      <MuiCircularProgress size={'1rem'} />
    </MuiIconButton>
  );

  const ActionCloneRelease = (
    <WithTooltip tooltip="Clone This Release">
      <MuiIconButton onClick={handleCloneReleaseClick}>
        <MuiFileCopyIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionAchiveToggle = (
    <WithTooltip tooltip={`${isArchived ? 'Unarchive' : 'Archive'} This Release`}>
      <MuiIconButton onClick={onArchiveToggle}>{isArchived ? <MuiUnarchiveIcon /> : <MuiArchiveIcon />}</MuiIconButton>
    </WithTooltip>
  );

  const ActionCancel = (
    <WithTooltip tooltip="Cancel">
      <MuiIconButton onClick={handleCancelClick}>
        <MuiBlockIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionChangeGroup = (
    <WithTooltip tooltip="Change Releases Group">
      <MuiIconButton onClick={handleChangeReleaseGroup}>
        <MuiChangeIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  const ActionEditUPC = (
    <WithTooltip tooltip="Edit UPC">
      <MuiIconButton onClick={handleChangeUPCGroup}>
        <MuiEditOutlinedIcon />
      </MuiIconButton>
    </WithTooltip>
  );

  if (!editing) {
    return (
      <>
        <WithTooltip tooltip="Reveal Row Actions" key="edit">
          <MuiIconButton onClick={handleEditClick}>
            <MuiEditAttributesIcon />
          </MuiIconButton>
        </WithTooltip>
      </>
    );
  }

  if (isCloning || isArchiving || isRefetching) {
    return ActionInProgress;
  }

  return (
    <>
      {ActionChangeGroup}
      {status !== 'Delivered' ? ActionEditUPC : null}
      {ActionCloneRelease}
      {ActionAchiveToggle}
      {ActionCancel}
    </>
  );
};

RowButtons.defaultProps = {
  disabled: {},
  hidden: {},
  onEditChange: () => {},
  onTransferClick: () => {},
  onCloneReleaseClick: () => {},
  transferStatus: {},
  cloneReleaseStatus: {},
};

export default RowButtons;
